import { Button, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TemplateAction from "../enums/TemplateAction";
import DeleteIcon from "../icons/DeleteIcon";

const TemplateCard = (props) => {
    const { template, onEditClick, onDeleteClick } = props
    const theme = useSelector((state) => state?.app?.theme);
    const { i18n } = useTranslation();
    return (<Grid
        container
        spacing={0}
        alignItems="center"
        className={`bg-card ${theme === 'dark' ? 'border' : ''}`}
        sx={{
            borderRadius: '2vw',
            position: 'relative',
            padding: "1.5rem",
            marginY: "1rem"
        }}
    >
        <Grid item xs={12} md={4}>
            <Typography
                className="dashboard-text-lg"
                variant="body1">
                {template.templateName}
            </Typography>
        </Grid>

        <Grid item xs="auto" md={6} sx={{
            display: 'flex', justifyContent: {
                xs: 'flex-start',
                md: 'flex-end',
            },
            alignItems: 'center', mt: { xs: 2, md: 0 },
            gap: 2
        }}>
            {template.doGenerateOnEndConversation && (
                <Grid item >
                    <Typography
                        variant="contained"
                        size="small"
                        sx={{
                            borderRadius: "20px",
                            border: 'green solid 1px',
                            color: theme === "dark" ? "#fff" : "#333",
                            textTransform: "none",
                            padding: { xs: "6px 10px", md: "10px" },
                            fontWeight: 500
                        }}
                    >
                        {i18n.t("templates.GENERATE_AFTER_CONVERSATION")}
                    </Typography>
                </Grid>
            )}
            {template.isDefaultNote && (
                <Grid item>
                    <Typography
                        variant="body2"
                        sx={{
                            borderRadius: "20px",
                            color: "#6C757D",
                            backgroundColor: "#F1F3F5",
                            textTransform: "none",
                            padding: { xs: "6px 10px", md: "10px" },
                            fontWeight: 500,
                        }}
                    >
                        {i18n.t("settings.DEFAULT")}
                    </Typography>
                </Grid>

            )}
        </Grid>

        <Grid item xs="auto" md={2} sx={{
            display: 'flex', justifyContent: {
                xs: "flex-start",
                md: "flex-end",
            }, alignItems: 'center', gap: 1, mt: { xs: 2, md: 0 },
        }}>
            <div
                onClick={onDeleteClick}
                style={{ cursor: 'pointer', color: "#B22234", display: 'flex', alignItems: 'center' }}
            >
                <DeleteIcon />
            </div>
            <Button
                variant="outlined"
                size="medium"
                onClick={onEditClick}
                sx={{padding: { xs: "4px 10px", md: undefined }}}
            >
                {i18n.t("templates.EDIT")}
            </Button>
        </Grid>

        {template.keywords && (<Grid item xs={12}>
            <Typography
                className="dashboard-text-md"
                variant="body2">
                <strong>Keywords:</strong> {template.keywords.join(" | ")}
            </Typography>
        </Grid>)}
    </Grid>)
}

export default TemplateCard;